import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  HistoryEntryIcon,
  HistoryEntryMainText,
  HistoryItemProps,
  HistoryEntrySubText,
  UserInfoDisplay,
} from "./common";

export const HistoryItemStatusReasonChanged = ({
  item,
  statusesConfig,
}: HistoryItemProps) => {
  const { details } = item;
  const statusReasonChange = details?.statusReasonChange;

  const getTitle = () => {
    if (statusReasonChange?.toStatusReason) {
      return `Status Reason Updated`;
    }
    return "Status Reason Changed";
  };

  return (
    <>
      <HistoryEntryIcon>
        <EditNoteIcon sx={{ height: 20, color: "#9C27B0" }} />
      </HistoryEntryIcon>

      <HistoryEntryMainText>{getTitle()}</HistoryEntryMainText>

      <UserInfoDisplay item={item} statusesConfig={statusesConfig} />

      {statusReasonChange?.toStatusReason && (
        <HistoryEntrySubText label="To">
          {statusReasonChange.toStatusReason}
        </HistoryEntrySubText>
      )}
      {statusReasonChange?.fromStatusReason && (
        <HistoryEntrySubText label="From">
          {statusReasonChange.fromStatusReason}
        </HistoryEntrySubText>
      )}
    </>
  );
};
